import React from 'react';
import {NextPage} from 'next';
import {StaticPageProps, withENV} from 'evcharging/app';
import {I18nPage} from 'i18n/types/pages.enum';
import Page from 'evcharging/components/Page';
import {ServiceHeader} from 'components/services/ServiceHeader';
import Navigation from 'evcharging/containers/layout/Navigation';
import ServiceContactForm from 'components/services/ServiceContactForm';
import FaqSection from 'evcharging/containers/layout/FaqSection';
import Footer from 'evcharging/containers/layout/Footer';
import {getDictionary} from 'i18n';
import {
  assetUrl,
  getPostsByCategory,
  getService,
  getServiceDefinedArticles,
  SERVICE_ARTICLES_LIMIT
} from 'evcharging/services/cmsClient';
import ServiceUtilitiesList from 'components/services/ServiceUtilitiesList';
import {BlogPost, E5Service} from 'evcharging/services/types';
import ServiceInfo from 'components/services/ServiceInfo';
import {GetServerSidePropsContext} from 'next/types';
import ServicePartners from "../../components/services/ServicePartners";
import {fortressPower, lgElectronics, siemensEnergy, sonnen} from "../../assets/images/services";

const listPartners = [
  {image: siemensEnergy, text: 'Siemens Energy'},
  {image: lgElectronics, text: 'LG Electronics'},
  {image: sonnen, text: 'sonnen'},
  {image: fortressPower, text: 'Fortress Power'},
]

const ServiceLandingPage: NextPage<StaticPageProps & { service: E5Service, posts: BlogPost[] }> = ({
                                                                                                     page,
                                                                                                     service,
                                                                                                     posts
                                                                                                   }) => {

  return (
    <Page title={page.meta_title} description={page.meta_description} locales={page.locales}>
      <Navigation hideSubNav/>
      <ServiceHeader
        serviceName={service.name}
        title={service.title}
        description={service.description}
        bgImage={assetUrl(service.header_bg)}
      />
      <ServiceInfo
        serviceName={service.name}
        info={service.info}
        infoImg={service.info_img}
      />
      <ServiceUtilitiesList utilities={service.utilities}/>
      {service.name === 'Battery Storage' &&
        <ServicePartners
          title={'Our Partners'}
          description={'We proudly partner with industry leaders to deliver innovative and reliable battery storage solutions.'}
          list={listPartners}
        />
      }
      <ServiceContactForm service={service}/>
      <FaqSection faqs={service.faqs}/>
      <Footer/>
    </Page>
  );
};

export const getServerSideProps = async ({
 params: urlParams,
 locale,
 defaultLocale
}: GetServerSidePropsContext): Promise<unknown> => {
  const i18n = await getDictionary(locale, defaultLocale, [I18nPage.Home, I18nPage.Blog]);
  const service = await getService(locale, String(urlParams.name));

  if (!service) {
    return {notFound: true};
  }

  const posts = [
    ...await getServiceDefinedArticles(locale, service.blog_posts),
    ...(await getPostsByCategory(locale, String(service.blog_category_id), 1, SERVICE_ARTICLES_LIMIT - service.blog_posts.length)).data,
  ];

  return {
    props: withENV({
      page: {
        meta_title: service.title,
        meta_description: service.description,
      },
      service,
      posts,
      i18n
    })
  };
};

export default ServiceLandingPage;
